import RentalListTable from './RentalListTable';
export default RentalListTable;
